interface TierListsShape {
  connect_user_auth_ids?: string[];
  ops_user_auth_ids?: string[];
  respond_user_auth_ids?: string[];
}

// "Subscribed" = assigned to a paid tier (Ops or Respond); "unsubscribed" = Connect.
// Splits a group's tier auth-id lists into paid (Ops + Respond) and connect buckets.
export function getGroupTierAuthIds(group: TierListsShape): {
  paidTierUserAuthIds: string[];
  connectTierUserAuthIds: string[];
} {
  return {
    paidTierUserAuthIds: (group.ops_user_auth_ids ?? []).concat(
      group.respond_user_auth_ids ?? [],
    ),
    connectTierUserAuthIds: group.connect_user_auth_ids ?? [],
  };
}
